import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import styles from './ScanFailureBanner.css';

const ScanFailureBanner = ({
  title,
  description,
  actionLabel,
  onAction,
  onDismiss,
  isFixed = false,
  fixedMessage,
  testId = 'scan-failure-banner'
}) => {
  if (isFixed) {
    return (
      <div
        className={styles.scanFailureBannerWrapper}
        role="status"
        data-test-id={`${testId}-fixed`}
      >
        <div className={styles.leftBarFixed} />
        <div className={styles.scanFailureBannerFixed}>
          <Icon
            name="check-small"
            size={20}
            className={styles.fixedIcon}
            aria-hidden
          />
          <div className={styles.fixedText}>{fixedMessage || title}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.scanFailureBannerWrapper}
      role="alert"
      data-test-id={testId}
    >
      <div className={styles.leftBarError} />
      <div className={styles.scanFailureBanner}>
        <Icon
          name="error-filled"
          size={20}
          className={styles.scanFailureBannerIcon}
          aria-hidden
        />
        <div className={styles.scanFailureBannerContent}>
          <div
            className={styles.scanFailureBannerTitle}
            data-test-id={`${testId}-title`}
          >
            {title}
          </div>
          {description && (
            <div
              className={styles.scanFailureBannerDescription}
              data-test-id={`${testId}-description`}
            >
              {description}
            </div>
          )}
          {actionLabel && onAction && (
            <button
              type="button"
              className={styles.scanFailureBannerAction}
              onClick={onAction}
              data-test-id={`${testId}-action`}
            >
              {actionLabel}
            </button>
          )}
        </div>
        {onDismiss && (
          <button
            type="button"
            className={styles.scanFailureBannerDismiss}
            onClick={onDismiss}
            aria-label="Dismiss error banner"
            data-test-id={`${testId}-dismiss`}
          >
            <Icon name="close-small" size={16} aria-hidden />
          </button>
        )}
      </div>
    </div>
  );
};

ScanFailureBanner.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  onDismiss: PropTypes.func,
  isFixed: PropTypes.bool,
  fixedMessage: PropTypes.string,
  testId: PropTypes.string
};

export default ScanFailureBanner;
